<template>
	<transition
			name="custom-classes-transition" 
			:enter-active-class="$_tbTabs_styleComponentAnimation()">
		<template v-if="$_tbTabs_stateComponentIsInitialized">
			<template v-if="$_tbTabs_stateComponentShowToolbarTabs">
				<v-row	no-gutters>
					<v-col>
						<v-row no-gutters>
							<v-col>
								<v-sheet class="sheet_" @click="$_tbTabs_closeTabs()" />
							</v-col>
						</v-row>
						<v-row no-gutters>
							<v-col>
								<!-- tabs -->
								<v-tabs	v-model="tab_"
										class="tabs_"
										:background-color="$_tbTabs_styleTabsBackgroundColor"
										:centered="$_tbTabs_styleTabsCentered"
										:color="$_tbTabs_styleTabsColor"
										:dark="$_tbTabs_styleTabsDark"
										:grow="$_tbTabs_styleTabsGrow"
										:hide-slider="$_tbTabs_styleTabsHideSlider"
										:light="$_tbTabs_styleTabsLight"
										:next-icon="$_tbTabs_styleTabsNextIcon"
										:prev-icon="$_tbTabs_styleTabsPrevIcon"
										:slider-color="$_tbTabs_styleTabsSliderColor">
									<template v-for="(tabVals, tabKey) in sortObject($_tbTabs_contents(), 'order')">
										<template v-if="$_tbTabs_checkMenu(tabVals) && checkMenuGroup(tabVals.menuGroup) && checkSecurityGroup(tabVals.securityGroup)">
											<v-tab	:key="tabKey">
												<v-row no-gutters>
													<template v-if="!isFalse(tabVals.icon)">
														<v-col class="center mr-1">
															<v-icon	:color="tabVals.iconColor"
																	v-text="tabVals.icon" />
														</v-col>
													</template>
													<v-col>
														<span	class="overline"
																v-html="$_tbTabs_langContentTabTitle(tabVals)" />
													</v-col>
													<template v-if="debugMode">
														<v-col class="ml-1" cols="auto">
															<debugger-order-alert :order="tabVals.order" />
														</v-col>
													</template>
												</v-row>
											</v-tab>
										</template>
									</template>
								</v-tabs>
							</v-col>
						</v-row>
						<v-row no-gutters>
							<v-col>
								<!-- tab items -->
								<v-tabs-items 
										v-model="tab_"
										class="tabsItems_"
										:continuous="$_tbTabs_styleTabsItemsContinuous"
										:dark="$_tbTabs_styleTabsItemsDark"
										:light="$_tbTabs_styleTabsItemsLight"
										:next-icon="$_tbTabs_styleTabsItemsNextIcon"
										:prev-icon="$_tbTabs_styleTabsItemsPrevIcon"
										:show-arrows="$_tbTabs_styleTabsItemsShowArrows"
										:show-arrows-on-hover="$_tbTabs_styleTabsItemsShowArrows">
									<template v-for="(tabVals, tabKey) in sortObject($_tbTabs_contents(), 'order')">
										<template v-if="$_tbTabs_checkMenu(tabVals) && checkMenuGroup(tabVals.menuGroup) && checkSecurityGroup(tabVals.securityGroup)">
											<v-tab-item :key="tabKey">
												<v-row dense>
													<template v-for="(menuItemVals, menuItemKey) in sortObject($_tbTabs_contentAppMenuItemsIsTabMenu, 'order')">
														<template v-if="$_tbTabs_checkTab(menuItemVals, tabKey) && checkMenuGroup(menuItemVals.menuGroup) && checkSecurityGroup(menuItemVals.securityGroup)">
															<v-col :key="menuItemKey" cols="auto">
																<v-btn	class="customVBtn"
																		:block="$_tbTabs_styleMenuButtonBlock"
																		:color="$_tbTabs_styleMenuButtonColor"
																		:dark="$_tbTabs_styleMenuButtonDark"
																		:depressed="$_tbTabs_styleMenuButtonDepressed"
																		:elevation="$_tbTabs_styleMenuButtonElevation"
																		:large="$_tbTabs_styleMenuButtonLarge"
																		:light="$_tbTabs_styleMenuButtonLight"
																		:outlined="$_tbTabs_styleMenuButtonOutlined"
																		:rounded="$_tbTabs_styleMenuButtonRounded"
																		:small="$_tbTabs_styleMenuButtonSmall"
																		:text="$_tbTabs_styleMenuButtonFlat"
																		@click="$_tbTabs_openLink(menuItemVals)">
																	<v-row no-gutters align="center">
																		<template v-if="!isFalse(menuItemVals.icon)">
																			<v-col class="center mr-1">
																				<v-icon :color="menuItemVals.iconColor"
																						v-text="menuItemVals.icon" />
																			</v-col>
																		</template>
																		<v-col class="center">
																			<span	class="overline"
																					v-html="$_tbTabs_langAppMenuTitle(menuItemVals)" />
																		</v-col>
																		<template v-if="debugMode">
																			<v-col class="ml-1" cols="auto">
																				<debugger-order-alert :order="menuItemVals.order" />
																			</v-col>
																		</template>
																	</v-row>
																</v-btn>
															</v-col>
														</template>
													</template>
												</v-row>
											</v-tab-item>
										</template>
									</template>
								</v-tabs-items>
							</v-col>
						</v-row>
					</v-col>
				</v-row>
			</template>
		</template>
	</transition>
</template>

<script>
	export default {
		name: 'ToolbarTabs',
		data() {
			return {
				componentName_: 'toolbarTabs',

				tab_: 0
			}
		},
		computed: {
			// state
			$_tbTabs_stateComponentIsInitialized() {
				const self_ = this;
				return self_.getComponentState('isInitialized')
			},
			$_tbTabs_stateComponentShowToolbarTabs() {
				const self_ = this;
				return self_.getComponentState('showToolbarTabs')
			},
			// app menu items
			$_tbTabs_contentAppMenuItems() {
				const self_ = this;
				const contents_ = self_.getAppContents('menuItems')
				return self_.getContentsSubset(contents_, 'isDummy', false)
			},
			$_tbTabs_contentAppMenuItemsIsTabMenu() {
				const self_ = this;
				const menuItems_ = self_.$_tbTabs_contentAppMenuItems;
				if(self_.isEmpty(menuItems_)) { return null }
				return self_.getContentsSubset(menuItems_, 'isTabMenu', true)
			},
			$_tbTabs_langAppMenuTitle() {
				const self_ = this;
				return menuItemVals => {
					return self_.getLangsVal(menuItemVals.title)
				}
			},
			// contents / inits
			$_tbTabs_contents() {
				const self_ = this;
				return () => {
					const contents_ = self_.getComponentContents(self_.componentName_)
					return self_.getContentsSubset(contents_, 'isDummy', false)
				}
			},
			$_tbTabs_inits() {
				const self_ = this;
				return () => {
					return self_.getComponentInits(self_.componentName_)
				}
			},
			// lang
			// (content)
			$_tbTabs_langContentTabTitle() {
				const self_ = this;
				return tabVals => {
					const title_ = tabVals.title;
					if(self_.isFalse(title_)) { return null }
					return self_.getLangsVal(title_)
				}
			},
			// style
			$_tbTabs_styleComponent() {
				const self_ = this;
				return () => {
					if(self_.isEmpty(self_.$_tbTabs_inits())) { return null }
					return self_.getInitsStyleVal(self_.$_tbTabs_inits(), 'component')
				}
			},
			$_tbTabs_styleComponentAnimation() {
				const self_ = this;
				return () => {
					const component_ = self_.$_tbTabs_styleComponent()
					if(self_.isFalse(component_)) { return null }
					return self_.getStylesVal(component_.animation)
				}
			},
			$_tbTabs_styleTabs() {
				const self_ = this;
				if(self_.isEmpty(self_.$_tbTabs_inits())) { return null }
				return self_.getInitsStyleVal(self_.$_tbTabs_inits(), 'tabs')
			},
			$_tbTabs_styleTabsBackgroundColor() {
				const self_ = this;
				const tabs_ = self_.$_tbTabs_styleTabs;
				if(self_.isFalse(tabs_)) { return null }
				return self_.getStylesVal(tabs_.backgroundColor)
			},
			$_tbTabs_styleTabsCentered() {
				const self_ = this;
				const tabs_ = self_.$_tbTabs_styleTabs;
				if(self_.isFalse(tabs_)) { return null }
				return self_.getStylesVal(tabs_.centered)
			},
			$_tbTabs_styleTabsColor() {
				const self_ = this;
				const tabs_ = self_.$_tbTabs_styleTabs;
				if(self_.isFalse(tabs_)) { return null }
				return self_.getStylesVal(tabs_.color)
			},
			$_tbTabs_styleTabsDark() {
				const self_ = this;
				const tabs_ = self_.$_tbTabs_styleTabs;
				if(self_.isFalse(tabs_)) { return null }
				return self_.getStylesVal(tabs_.dark)
			},
			$_tbTabs_styleTabsGrow() {
				const self_ = this;
				const tabs_ = self_.$_tbTabs_styleTabs;
				if(self_.isFalse(tabs_)) { return null }
				return self_.getStylesVal(tabs_.grow)
			},
			$_tbTabs_styleTabsHideSlider() {
				const self_ = this;
				const tabs_ = self_.$_tbTabs_styleTabs;
				if(self_.isFalse(tabs_)) { return null }
				return self_.getStylesVal(tabs_.hideSlider)
			},
			$_tbTabs_styleTabsLight() {
				const self_ = this;
				const tabs_ = self_.$_tbTabs_styleTabs;
				if(self_.isFalse(tabs_)) { return null }
				return self_.getStylesVal(tabs_.light)
			},
			$_tbTabs_styleTabsNextIcon() {
				const self_ = this;
				const tabs_ = self_.$_tbTabs_styleTabs;
				if(self_.isFalse(tabs_)) { return null }
				return self_.getStylesVal(tabs_.nextIcon)
			},
			$_tbTabs_styleTabsPrevIcon() {
				const self_ = this;
				const tabs_ = self_.$_tbTabs_styleTabs;
				if(self_.isFalse(tabs_)) { return null }
				return self_.getStylesVal(tabs_.prevIcon)
			},
			$_tbTabs_styleTabsSliderColor() {
				const self_ = this;
				const tabs_ = self_.$_tbTabs_styleTabs;
				if(self_.isFalse(tabs_)) { return null }
				return self_.getStylesVal(tabs_.sliderColor)
			},
			$_tbTabs_styleTabsItems() {
				const self_ = this;
				if(self_.isEmpty(self_.$_tbTabs_inits())) { return null }
				return self_.getInitsStyleVal(self_.$_tbTabs_inits(), 'tabsItems')
			},
			$_tbTabs_styleTabsItemsContinuous() {
				const self_ = this;
				const tabsItems_ = self_.$_tbTabs_styleTabsItems;
				if(self_.isFalse(tabsItems_)) { return null }
				return self_.getStylesVal(tabsItems_.continuous)
			},
			$_tbTabs_styleTabsItemsDark() {
				const self_ = this;
				const tabsItems_ = self_.$_tbTabs_styleTabsItems;
				if(self_.isFalse(tabsItems_)) { return null }
				return self_.getStylesVal(tabsItems_.dark)
			},
			$_tbTabs_styleTabsItemsLight() {
				const self_ = this;
				const tabsItems_ = self_.$_tbTabs_styleTabsItems;
				if(self_.isFalse(tabsItems_)) { return null }
				return self_.getStylesVal(tabsItems_.light)
			},
			$_tbTabs_styleTabsItemsNextIcon() {
				const self_ = this;
				const tabsItems_ = self_.$_tbTabs_styleTabsItems;
				if(self_.isFalse(tabsItems_)) { return null }
				return self_.getStylesVal(tabsItems_.nextIcon)
			},
			$_tbTabs_styleTabsItemsPrevIcon() {
				const self_ = this;
				const tabsItems_ = self_.$_tbTabs_styleTabsItems;
				if(self_.isFalse(tabsItems_)) { return null }
				return self_.getStylesVal(tabsItems_.prevIcon)
			},
			$_tbTabs_styleTabsItemsShowArrows() {
				const self_ = this;
				const tabsItems_ = self_.$_tbTabs_styleTabsItems;
				if(self_.isFalse(tabsItems_)) { return null }
				return self_.getStylesVal(tabsItems_.showArrows)
			},
			$_tbTabs_styleMenuButton() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.$_tbTabs_inits(), 'menuButton')
			},
			$_tbTabs_styleMenuButtonBlock() {
				const self_ = this;
				const button_ = self_.$_tbTabs_styleMenuButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.block)
			},
			$_tbTabs_styleMenuButtonColor() {
				const self_ = this;
				const button_ =self_.$_tbTabs_styleMenuButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.color)
			},
			$_tbTabs_styleMenuButtonDark() {
				const self_ = this;
				const button_ = self_.$_tbTabs_styleMenuButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.dark)
			},
			$_tbTabs_styleMenuButtonDepressed() {
				const self_ = this;
				const button_ = self_.$_tbTabs_styleMenuButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.depressed)
			},
			$_tbTabs_styleMenuButtonElevation() {
				const self_ = this;
				const button_ = self_.$_tbTabs_styleMenuButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.elevation)
			},
			$_tbTabs_styleMenuButtonFlat() {
				const self_ = this;
				const button_ = self_.$_tbTabs_styleMenuButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.flat)
			},
			$_tbTabs_styleMenuButtonLarge() {
				const self_ = this;
				const button_ = self_.$_tbTabs_styleMenuButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.large)
			},
			$_tbTabs_styleMenuButtonLight() {
				const self_ = this;
				const button_ = self_.$_tbTabs_styleMenuButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.light)
			},
			$_tbTabs_styleMenuButtonOutlined() {
				const self_ = this;
				const button_ = self_.$_tbTabs_styleMenuButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.outlined)
			},
			$_tbTabs_styleMenuButtonRounded() {
				const self_ = this;
				const button_ = self_.$_tbTabs_styleMenuButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.rounded)
			},
			$_tbTabs_styleMenuButtonSmall() {
				const self_ = this;
				const button_ = self_.$_tbTabs_styleMenuButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.small)
			}
		},
		methods: {
			$_tbTabs_checkMenu(tab) {
				const self_ = this;

				const toolbar_ = self_.getComponentState('toolbar')
				const menu_ = toolbar_.menu;

				return tab.menu[menu_]
			},
			$_tbTabs_checkTab(menu, key) {
				const self_ = this;

				if(self_.isEmpty(menu.tab)) { return null }
				return menu.tab[key]
			},
			$_tbTabs_openLink(menu) {
				const self_ = this;
				self_.setComponentState('showToolbarTabs', false)
				self_.openLink(menu.link)
			},
			$_tbTabs_closeTabs() {
				const self_ = this;
				self_.setComponentState('showToolbarTabs', false)
			}
		}
	}
</script>

<style scoped>
	.tabs_ {
		left:0; 
		top:0; 
		position: absolute; 
		width: 100vw;
	}
	.tabsItems_ {
		left:0; 
		top:0; 
		position: absolute; 
		margin-top: 48px; 
		width: 100vw;
		padding: 0 16px;
	}
	.sheet_ {
		height: 100%;
		width: 100vw;
		position: absolute;
		top: 0;
		left: 0;

		background-color: #0009;
		background-position: center top;
		background-attachment: fixed;
		background-size: cover;
	}
</style>